var exports = {
  "iE": "EmbedCard.module__wrapper___TlBGc3",
  "p_": "EmbedCard.module__splashWrapper___TlBGc3",
  "Yi": "EmbedCard.module__splash___TlBGc3",
  "Vg": "EmbedCard.module__grid___TlBGc3",
  "iA": "EmbedCard.module__iconSlot___TlBGc3",
  "Qs": "EmbedCard.module__content___TlBGc3",
  "wx": "EmbedCard.module__header___TlBGc3",
  "$": "EmbedCard.module__titleRow___TlBGc3",
  "VA": "EmbedCard.module__subtitle___TlBGc3",
  "rf": "EmbedCard.module__body___TlBGc3",
  "yF": "EmbedCard.module__divider___TlBGc3",
  "DD": "EmbedCard.module__title___TlBGc3",
  "N4": "EmbedCard.module__titleButton___TlBGc3",
  "jn": "EmbedCard.module__titlePrimary___TlBGc3",
  "S3": "EmbedCard.module__titleDanger___TlBGc3",
  "BK": "EmbedCard.module__helpText___TlBGc3",
  "_O": "EmbedCard.module__iconCircleDisabled___TlBGc3",
  "m5": "EmbedCard.module__iconError___TlBGc3",
  "qV": "EmbedCard.module__skeleton___TlBGc3",
  "mj": "EmbedCard.module__skeletonCircle___TlBGc3",
  "Iz": "EmbedCard.module__skeletonTitle___TlBGc3",
  "wS": "EmbedCard.module__skeletonSubtitle___TlBGc3",
  "VR": "EmbedCard.module__skeletonIcon___TlBGc3",
  "X1": "EmbedCard.module__skeletonDot___TlBGc3",
  "gH": "EmbedCard.module__skeletonStat___TlBGc3",
  "Ye": "EmbedCard.module__skeletonStatShort___TlBGc3",
  "KJ": "EmbedCard.module__skeletonStatLong___TlBGc3",
  "G3": "EmbedCard.module__skeletonButton___TlBGc3",
};

module.exports = exports;
